
import { FilterOption } from '@/components/ui/FilterDropdown';

interface ActiveSelectionsProps {
  selectedStyle: string;
  selectedInfluence: string;
  selectedBackground: string;
  colorOptions: FilterOption[];
  backgroundOptions: FilterOption[];
  environmentOptions: FilterOption[];
}

export const useActiveSelections = ({
  selectedStyle,
  selectedInfluence,
  selectedBackground,
  colorOptions,
  backgroundOptions,
  environmentOptions
}: ActiveSelectionsProps) => {
  
  // Get active selections for prompt generation
  const getActiveSelections = () => {
    // Selected style active option
    const activeStyleOptions = selectedStyle
      ? [{ id: selectedStyle, label: "Selected Style", checked: true }]
      : [];

    // Selected influence active option
    const activeInfluenceOptions = selectedInfluence
      ? [{ id: selectedInfluence, label: "Selected Influence", checked: true }]
      : [];
  
    // Color filter active options  
    const activeColorOptions = colorOptions.filter(o => o.checked);
    
    // Background active options
    const activeBackgroundOptions = getActiveBackgroundOptions();
    
    // Environment active options
    const activeEnvironmentOptions = environmentOptions.filter(o => o.checked);
    
    return {
      activeStyleOptions,
      activeInfluenceOptions,
      activeColorOptions,
      activeBackgroundOptions,
      activeEnvironmentOptions
    };
  };
  
  // Helper to get active background option
  const getActiveBackgroundOptions = (): FilterOption[] => {
    const selectedOpt = backgroundOptions.find(o => o.id === selectedBackground);
    return selectedOpt ? [selectedOpt] : [];
  };
  
  return {
    getActiveSelections,
    getActiveBackgroundOptions
  };
};
